import { Routes } from '@angular/router';
import { inject } from '@angular/core';
import { pageDataResolver } from './core/resolvers/resolver-resolver';
import { isStateCodeGuard } from './core/guards/is-state-code.guard';
import { rootRedirectGuard } from './core/guards/root-redirect.guard';
import { cartGuard } from './core/guards/cart.guard';
import { invoiceGuard } from './core/guards/invoice.guard';
import { UsStatesService } from './core/services/us-states.service';

export const routes: Routes = [
    {
        path: '',
        // canActivate: [rootRedirectGuard],
        // loadComponent: () => import('./features/daynamic-pages/daynamic-pages').then(m => m.DaynamicPages),
        // runGuardsAndResolvers: 'always'  // add this
        loadComponent: () => import('./features/select-state/select-state').then(m => m.SelectState),
        resolve: { data: pageDataResolver },

    },
    {
        path: 'select-state',
        loadComponent: () => import('./features/select-state/select-state').then(m => m.SelectState),
    },
    {
        path: 'contact',
        loadComponent: () => import('./shared/components/pages/contact/contact').then(m => m.Contact),
    },
    {
        path: 'cart',
        loadComponent: () => import('./shared/components/pages/cart/cart').then(m => m.Cart),
        canActivate: [cartGuard]
    },
    {
        path: 'order-form',
        loadComponent: () => import('./shared/components/pages/order-form/order-form').then(m => m.OrderForm),
        canActivate: [cartGuard]
    },
    {
        path: 'shipping',
        loadComponent: () => import('./shared/components/pages/shipping/shipping').then(m => m.ShippingComponent),
        canActivate: [cartGuard]
    },
    {
        path: 'payment',
        loadComponent: () => import('./shared/components/pages/payment/payment').then(m => m.Payment),
        canActivate: [cartGuard]
    },
    {
        path: 'invoice',
        loadComponent: () => import('./shared/components/pages/invoice/invoice').then(m => m.Invoice),
        canActivate: [invoiceGuard]
    },
    {
        path: 'thank-you',
        loadComponent: () => import('./shared/components/pages/thank-you/thank-you').then(m => m.ThankYouComponent)
    },
    {
        path: ':stateCode/:slug',
        canMatch: [isStateCodeGuard],
        loadComponent: () => import('./features/daynamic-pages/daynamic-pages').then(m => m.DaynamicPages),
        resolve: {
            data: pageDataResolver,
            stateDetails: (route: import('@angular/router').ActivatedRouteSnapshot) => {
                const code = route.params['stateCode'];
                return inject(UsStatesService).loadStateDetails(code);
            }
        },
        runGuardsAndResolvers: 'always'
    },
    {
        path: ':stateCode',
        canMatch: [isStateCodeGuard],
        loadComponent: () => import('./features/state-page/state-page').then(m => m.StatePage),
        resolve: {
            stateDetails: (route: import('@angular/router').ActivatedRouteSnapshot) => {
                const code = route.params['stateCode'];
                return inject(UsStatesService).loadStateDetails(code);
            }
        }
    },
    {
        path: '404',
        loadComponent: () => import('./features/not-found/not-found').then(m => m.NotFound),
    },
    {
        path: '**',
        loadComponent: () => import('./features/daynamic-pages/daynamic-pages').then(m => m.DaynamicPages),
        resolve: { data: pageDataResolver },
        runGuardsAndResolvers: 'always'
    }
];
